import { z } from "zod";

export const StateSchema = z.object({
	id: z.number(),
	global_country_id: z.number(),
	name: z.string(),
	code: z.string(),
	description: z.string(),
	country_numcode: z.number(),
	timezone: z.string(),
	timezone_id: z.number(),
	allow_surcharge: z.number(),
	max_surcharge: z.number(),
});

export const StatesSchema = z.object({
	states: z.array(StateSchema),
});

export type State = z.infer<typeof StateSchema>;
export type States = z.infer<typeof StatesSchema>;
